import styled from 'styled-components';

export const Container = styled.button`
  width: auto;
  min-width: 132px;
  height: 50px;
  padding: 0 18px;

  border-radius: 16px;
  font-weight: 900;
  font-size: 15px;

  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;

  cursor: pointer;

  transition: transform 0.15s ease, filter 0.2s ease, opacity 0.2s ease,
    background 0.2s ease, border-color 0.2s ease, box-shadow 0.2s ease;

  &[data-variant='primary'] {
    border: 0;
    color: hsl(var(--primary-foreground));
    background: linear-gradient(135deg, hsl(var(--primary)), hsl(var(--warm)));
    box-shadow: 0 0 16px hsl(var(--primary) / 0.24),
      0 0 42px hsl(var(--primary) / 0.08),
      0 16px 38px hsl(var(--background) / 0.42);
  }

  &[data-variant='ghost'] {
    background: linear-gradient(
      180deg,
      hsl(var(--card) / 0.7),
      hsl(var(--background) / 0.7)
    );
    border: 1px solid hsl(var(--foreground) / 0.1);
    color: hsl(var(--sky));
    box-shadow: 0 10px 28px hsl(var(--background) / 0.45);
  }

  &[data-fullwidth='true'] {
    width: 100%;
  }

  &:hover {
    transform: translateY(-1px);
    filter: brightness(1.05);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    transform: none;
  }
`;
